module.exports = __webpack_public_path__ + "assets/0cb51bf0429928ee4ccb29de558df3de.mp3";